import CancelIcon from '@mui/icons-material/Cancel';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, CircularProgress, Divider, FormControl, IconButton, InputAdornment, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, OutlinedInput } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAdminMaxLocations } from '../../../hooks/useAdminMaxLocations';

export const MaxLocationList = () => {
    const [filter, setFilter] = useState<string>('');

    const { data: maxLocations = [], isFetched } = useAdminMaxLocations();
    const navigate = useNavigate();

    const getFilteredLocations = () => {
        if (filter.length > 0) {
            const filterRegex = new RegExp(filter, 'gi');

            return maxLocations.filter(({ name, description }) => {
                return `${name} ${description}`.match(filterRegex);
            });
        }
        return maxLocations;
    };

    const handleSelectedLocation = (id: string) => {
        navigate(`/admin/max-locations/${id}`);
    };

    return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 3, maxWidth: (theme) => theme.breakpoints.values.sm }}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="filter-max-locations">Filter Locations</InputLabel>
                        <OutlinedInput
                            id="filter-max-locations"
                            fullWidth
                            label="Filter Locations"
                            value={filter}
                            onChange={(event) => setFilter(event.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton aria-label={'clear the filter'} edge="end" onClick={() => setFilter('')}>
                                        <CancelIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Box>
                <Divider />
                <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {!isFetched && <CircularProgress />}
                    {isFetched && (
                        <List sx={{ width: '100%', height: '100%', overflowY: 'scroll', p: 0 }}>
                            {getFilteredLocations().map((location) => {
                                const { _id, name, description } = location;

                                return (
                                    <ListItemButton key={_id.toString()} divider={true} onClick={() => handleSelectedLocation(_id.toString())}>
                                        <ListItemText primary={name} secondary={description} />
                                        <ListItemIcon>
                                            <NavigateNextIcon />
                                        </ListItemIcon>
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
